// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bh-b";
export var colorBlue = "_bh-8";
export var colorDot = "_bh-0";
export var colorDotLarge = "_bh-2";
export var colorDotSmall = "_bh-1";
export var colorGreen = "_bh-7";
export var colorGrey = "_bh-3";
export var colorOrange = "_bh-5";
export var colorPink = "_bh-a";
export var colorPurple = "_bh-9";
export var colorRed = "_bh-4";
export var colorYellow = "_bh-6";